import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { getCategoryTitle, LifeStyleSubCategoryEnum, PropertyAreaUnitEnum } from '@classifieds-sell/datalayer';
import { from, Subject } from 'rxjs';
import { getFullAddress } from '../../../../helpers/address.helper';
import { StepIds } from '../../../../models/property-step/property-step-model';
import { PropertySectionBase } from '../../../property-section-base';
import { IRouterData, RouterFacade } from '@classifieds-sell/state';
import { takeUntil } from 'rxjs/operators';
import { DraftFacade } from '@classifieds-sell/state';

@Component({
    selector: 'property-summary-page-property-information-section',
    templateUrl: './summary-page-property-information-section.component.html',
    styleUrls: ['./summary-page-property-information-section.component.scss']
})
export class LifeStyleSummaryPagePropertyInformationSectionComponent
    extends PropertySectionBase
    implements OnInit, OnDestroy {
    stepIds = StepIds;
    category: string;
    address: string;
    landAreaWithUnit: string;
    routerData: IRouterData;
    isDwellingSubcategory: boolean;
    bedrooms: string;
    bathrooms: string;
    floorArea: string;
    toilets: string;
    ensuites: string;
    lounges: string;
    studies: string;
    homeAndIncome: string;
    garageParking: string;
    offStreetParking: string;
    parkingDetails: string;

    private _destroyed$: Subject<void> = new Subject<void>();

    constructor(
        draftFacade: DraftFacade,
        public routerFacade: RouterFacade,
        private _changeDetectorRef: ChangeDetectorRef
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            this.getRouteData();

            this.address = getFullAddress(
                this.draftData.propertyInformation,
                this.metadata.regions
            );

            const propertyAreaUnitSymbol =
                this.draftData.propertyInformation.propertyAreaUnit === PropertyAreaUnitEnum.Hectares
                ? 'ha' : 'ac';
            this.landAreaWithUnit = `${this.draftData.propertyInformation.propertyArea} ${propertyAreaUnitSymbol}` ;
            if(this.isDwellingSubcategory){
                if (this.draftData.propertyInformation.bedrooms === 6) {
                    this.bedrooms =
                        this.draftData.propertyInformation.bedrooms + '+';
                } else if (this.draftData.propertyInformation.bedrooms === 0) {
                    this.bedrooms = this.metadata.bedrooms.find(x => x.value === 0).display;
                }else {
                    this.bedrooms = this.draftData.propertyInformation.bedrooms;
                }
                this.bathrooms = this.attributeValueForDisplay('bathrooms');
                this.floorArea = this.draftData.propertyInformation.floorArea
                    ? this.draftData.propertyInformation.floorArea.toLocaleString() + 'm²'
                    : '';
                this.toilets = this.attributeValueForDisplay('toilets');
                this.ensuites = this.attributeValueForDisplay('ensuites');
                this.lounges = this.attributeValueForDisplay('lounges');
                this.studies = this.attributeValueForDisplay('studies');
                switch (this.draftData.propertyInformation.homeAndIncome) {
                    case 1:
                        this.homeAndIncome = 'Yes';
                        break;
                    case 0:
                        this.homeAndIncome = 'No';
                        break;
                    default:
                        this.homeAndIncome = '-';
                        break;
                }
                this.garageParking = this.attributeValueForDisplay('garageParking');
                this.offStreetParking = this.attributeValueForDisplay('offStreetParking');
                this.parkingDetails = this.draftData.propertyInformation.parkingDetails;
            }

            this._changeDetectorRef.markForCheck();
        });
    }

    private attributeValueForDisplay(key: string): string {
        if (this.draftData.propertyInformation[key] === 6) {
            return this.draftData.propertyInformation[key] + '+';
        } else {
            return this.draftData.propertyInformation[key];
        }
    }

    getRouteData(): void {
        from(this.routerFacade.routerData$)
            .pipe(takeUntil(this._destroyed$))
            .subscribe((routerStateData) => {
                this.routerData = routerStateData;
                this.category = getCategoryTitle(this.categoryId, this.routerData.subCategory);
                this.isDwellingSubcategory = this.routerData.subCategory === LifeStyleSubCategoryEnum.dwelling;
            });
    }

    isValid(): boolean {
        return true;
    }

    dirty(): boolean {
        return false;
    }
}
